import { render, staticRenderFns } from "./SectionSearch.vue?vue&type=template&id=028e1cc6&scoped=true"
import script from "./SectionSearch.vue?vue&type=script&lang=ts"
export * from "./SectionSearch.vue?vue&type=script&lang=ts"
import style0 from "./SectionSearch.vue?vue&type=style&index=0&id=028e1cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e1cc6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutsHeaderTheA: require('/usr/src/nuxt-app/components/layouts/header/TheA.vue').default})
